<template>
    <div>
        <div>
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i> Фильтр</span><span class="rc"><i
                            class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span>Параметры фильтра</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <!---------------------год------------------------->
                            <div class="filter-block">
                                <b-form-group label="Год">
                                    <multiselect
                                        v-model="repYear"
                                        placeholder="Выберите год"
                                        :options="yearList"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="loadRegions"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <!---------------------регион------------------------->
                            <div class="filter-block">
                                <b-form-group label="Регион">
                                    <multiselect
                                        v-model="curReg"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выберите регион"
                                        :options="regions"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="loadAbp"
                                        ref="regionsRef"
                                    >
                                        <template
                                            slot="singleLabel"
                                            slot-scope="{ option }"
                                        >
                                            <span>{{ option.name }}</span>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <!----------------Администратор программ abp------------------->
                            <div class="filter-block">
                                <b-form-group label="АБП">
                                    <multiselect
                                        v-model="curAbp"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выберите АБП"
                                        :options="abp"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgAbp"
                                        ref="abpRef"
                                    >
                                        <template
                                            slot="singleLabel"
                                            slot-scope="{ option }"
                                        >
                                            <span>{{ option.name }}</span>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <!-------------Программа prog---------------------->
                            <div class="filter-block">
                                <b-form-group label="Программа">
                                    <multiselect
                                        v-model="curProg"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать программу"
                                        :options="prog"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgProg"
                                        ref="curProgRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!------------------------Подпрограмма subProg------------------------------------->
                            <div class="filter-block">
                                <b-form-group label="Подпрограмма">
                                    <multiselect
                                        v-model="curSubProg"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать подпрограмму"
                                        :options="subProg"
                                        :searchable="true"
                                        :allow-empty="true"
                                        :show-labels="false"
                                        @input="chgSubProg"
                                        ref="subProgRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!------------------------Подпрограмма spf------------------------------------->
                            <div class="filter-block">
                                <b-form-group label="Специфика">
                                    <multiselect
                                        v-model="curSpf"
                                        track-by="spf"
                                        label="name"
                                        placeholder="Выбрать специфику"
                                        :options="spf"
                                        :searchable="true"
                                        :allow-empty="true"
                                        :show-labels="false"
                                        ref="spfRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-button variant="primary" @click="chgData">Применить</b-button>
                            </div>
                            <div class="filter-block">
                                <b-form-group label="Статус ПФ">
                                    <multiselect
                                        v-model="selectedStatus"
                                        placeholder="Выберите статус"
                                        :options="statusListPf"
                                        track-by="name_ru"
                                        label="name_ru"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        ref="refStatus"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group label="Трансферт">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="transfert" switch />
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
                <div class="filter-actions">
                    <b-button v-if="operationCode.length > 0" v-show="agrEnabled" variant="success" @click="agreementEvent">Действия</b-button>
                </div>
            </div>
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" @click="openHistory(currentForm)" v-if="currentForm && currentForm.hasOwnProperty('status') && currentForm.status">
                    {{ getLocalStatus(currentForm) }}
                </span>
                <span class="item-breadcrumb" @click="openFilterByRef('yearRef')">
                    {{ repYear }}
                </span>
                <span class="item-breadcrumb" v-if="curReg" @click="openFilterByRef('regionsRef')">
                    {{ curReg.name }}
                </span>
                <span class="item-breadcrumb" v-if="curAbp && curAbp.hasOwnProperty('abp') && curAbp.abp"
                      @click="openFilterByRef('abpRef')">
                    {{ curAbp.abp }}-АБП
                </span>
                <span class="item-breadcrumb" v-if="curProg && curProg.hasOwnProperty('prg') && curProg.prg"
                      @click="openFilterByRef('curProgRef')">
                    {{ curProg.prg }}-БП
                </span>
                <span class="item-breadcrumb" v-if="curSubProg && curSubProg.hasOwnProperty('ppr') && curSubProg.ppr"
                      @click="openFilterByRef('subProgRef')">
                    {{ curSubProg.ppr }}-БПП
                </span>
                <span :title="curSpf.name" class="item-breadcrumb" v-if="curSpf && curSpf.hasOwnProperty('spf') && curSpf.spf"
                      @click="openFilterByRef('spfRef')">
                    {{ curSpf.name.substring(0, 40) }}...
                </span>
                <span class="item-breadcrumb" v-if="selectedStatus && selectedStatus.hasOwnProperty('code') && selectedStatus.code">
                    {{ selectedStatus.name_ru }}
                </span>
            </div>
        </div>

        <div>
            <b-progress variant="primary" v-show="bar<100" height="3px" :value="bar" striped animated></b-progress>
            <div>
                <b-tabs class="tabs-in-tabs">
                    <b-tab>
                        <template #title>
                            <button class="icon-btn" @click="toggleShowObligation">
                                <i class="icon icon-keyboard icon-rotate-270" v-if="showObligation"></i>
                                <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                            </button>
                            <span class="ml-2">
                                Обязательства
                            </span>
                        </template>
                        <div class="top-table-line"></div>
                        <c-spf-table :table-data-parents="budgetFormObligationData" :show-data="showObligation" :table-data="budgetFormObligation"/>
                    </b-tab>
                </b-tabs>
            </div>
            <div>
                <b-tabs class="tabs-in-tabs">
                    <b-tab>
                        <template #title>
                            <button class="icon-btn" @click="toggleShowPayment">
                                <i class="icon icon-keyboard icon-rotate-270" v-if="showPayment"></i>
                                <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                            </button>
                            <span class="ml-2">
                            Платежи
                        </span>
                        </template>
                        <div class="top-table-line"></div>
                        <c-spf-table :table-data-parents="budgetFormPaymentData" :show-data="showPayment" :table-data="budgetFormPayment"/>
                    </b-tab>
                </b-tabs>
            </div>
            <c-budg-agr-modal
                ref="refAgrModal"
                :agr-btn-lst="agrBtnLst"
                @agrClk="agrClick"
            ></c-budg-agr-modal>
            <b-exec-agr-hist-modal ref="refHistModal" :mode_code="'exspf'" :status-types="statusList"/>
        </div>
    </div>
</template>

<script>
import store from '@/services/store';
import CSpfTable from '../components/SpfTable.vue';
import {Ax} from '@/utils';
import axios from "axios";
import CBudgetAgreementModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue";
import BExecAgrHistModal from '@/modules/budget/execution/form/tabs/components/BExecAgrHistModal.vue'
import {EventBus} from "@/modules/budget/eventBus";

export default {
    $refs: {
        refHistModal: HTMLFormElement
    },
    name: 'BudgetExecutionSpf',
    components: { CSpfTable, 'c-budg-agr-modal': CBudgetAgreementModal, 'b-exec-agr-hist-modal': BExecAgrHistModal },
    props: {
        accessLevel: null,
        obl: null
    },
    data() {
        return {
            budgetFormObligation: [],
            budgetFormObligationData: [],
            budgetFormPayment: [],
            budgetFormPaymentData: [],
            calcFlds: [
                'plan',
                'january',
                'february',
                'march',
                'april',
                'may',
                'june',
                'july',
                'august',
                'september',
                'october',
                'november',
                'december'
            ],

            currentForm: null,
            currentSPPForm: null,
            statusList: [],
            statusListPf: [],
            selectedStatus: null,
            operationCode: [],
            agrBtnLst: { back: [], forward: [] },
            selectArr: [],
            agrEnabled: false,
            isChildsAgreedUF: false,

            yearList: [],
            repYear: (new Date()).getFullYear(),
            listReg: null,
            reg: null,

            months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
            filter: null,

            bar: 0,
            isLoad: false,
            showObligation: true,
            showPayment: true,

            abpBase: [],
            curAbp: null,

            regBase: [],
            curReg: null,

            progBase: [],
            curProg: null,

            subProgBase: [],
            curSubProg: null,

            spfBase: [],
            curSpf: null,

            editAccess: null,
            moduleCode: '005.001.005',
            mode: 'exspf',
            form: 'spf',
            previousFormId: null,
            transfert: false,
            queryParams: null
        };
    },
    async created() {
        this.queryParams = Object.keys(this.$route.query).length ? this.$route.query : null;
        const curDate = new Date()
        this.repYear = curDate.getFullYear();
        for (let i = 2022; i <= this.repYear; i++) {
            this.yearList.push(i);
        }
        if (curDate.getMonth() > 9) {
            this.yearList.push(this.repYear + 1)
            this.repYear += 1
        }

        if (this.queryParams?.year) {
            this.repYear = parseInt(this.queryParams.year)
        }
        await this.loadOperations();
        await this.loadRegions();
        if (this.queryParams) {
            if (this.queryParams.region) {
                const f_region = this.regBase.find(it => it.code === this.queryParams.region);
                if (f_region) {
                    this.curReg = f_region;
                    await this.loadAbp()
                } else {
                    this.curReg = this.regBase.length ? this.regBase[0] : null;
                    this.makeToast('danger', "Доступ", "Внимание!. Регион не доступен")
                }
            }
        }
        this.getEditAccess();
        this.statusList = await this.getStatusList(this.mode)
        this.statusListPf = await this.getStatusList('expf')
        if (this.statusListPf.length) {

            this.selectedStatus = this.statusListPf.find(el => { if (el.code === 32) return el })
        }
        EventBus.$on('formationPfFormChanged', (formData) => {
            this.formationIpfFormChanged(formData)
        });
        EventBus.$on('formSPPChanged', (formData) => {
            if (formData.region === this.currentForm.region && formData.year === this.currentForm.year) {
                this.getCurrentSPPForm()
            }
        })
        this.$emit('curYear', this.repYear);
        this.$watch('currentForm', async () => {
            if (this.currentForm) {
                await this.getCurrentSPPForm()
                await this.agreementEvent(false);
                this.isChildsAgreedUF = true;
                for (const el of this.currentForm.childList) {
                    if (![32, 39].includes(el.status.status)) {
                        this.isChildsAgreedUF = false;
                        break
                    }
                }
            }
        }, { deep: true });
        this.$emit('registerComponent', this, this.form)
        await this.getCurrentForm()
        await this.chgData()
        this.bar = 100;
        this.queryParams = null
    },

    async mounted() {

    },

    methods: {
        downloadIISKReport(app) {
            const url = '/api/budget-execution-base/xls'
            const params = {
                type: app % 2 || app === 6? 'PAYMENT': 'OBLIGATION',
                addAllAgreed: false,
                addIpf: true,
                addSpp: app === 6,
                dataLevel: [1, 2].includes(app) ? 'SPF' : 'PRG',
                year: this.repYear,
                region: this.curReg.code,
                level: [1, 2].includes(app) ? 'GU' : 'UF'
            }
            if (app === 6) {
                params['code'] = 'UTV_P_MB'
            } else if ([1, 2].includes(app)) {
                params['code'] = 'IPF_PO'
            } else {
                params['code'] = 'SPF_PO'
            }
            if (app !== 6) {
                params['planType'] = 'EXPENSE'
            }
            if (this.curAbp && this.curAbp.hasOwnProperty('abp') && this.curAbp.abp) {
                params['abp'] = this.curAbp.abp
            }
            Ax(
                {
                    url: url,
                    method: 'GET',
                    params: params,
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const planType =  app % 2? 'Платежи': 'Обязательства'
                    const year_reg = `_${this.curReg.code}_${this.repYear}`
                    let name = `СПФ(${planType})`
                    if (app === 6) {
                        name = 'Утвержденный план'
                    } else if ([1, 2].includes(app)) {
                        name = `ИПФ(${planType})`
                    }
                    name += year_reg + '.xls';
                    link.setAttribute('download', name);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepPayments()', error.toString());
                }
            );
        },
        getEditAccess() {
            const avModules = store.state.user.userModules
            for (const avModule of avModules) {
                if (avModule.modules === this.moduleCode) {
                    this.editAccess = Object.assign({}, avModule)
                    break
                }
            }
        },

        async loadRegions() {
            let response =[];
            try {
                response = await fetch(`/api-py/get-user-regions-by-obl/${this.obl}/${this.usrId}/${this.repYear}`).then(response => response.json());
            } catch (error) {
                response = [];
                this.makeToast('danger', 'Ошибка загрузки Регионов', error.toString());
            }
            this.regBase = response;

            if (this.regBase.length > 0) {
                this.curReg = this.regBase[0];
                await this.loadAbp();
            } else {
                this.curReg = null;
            }
        },

        async loadAbp() {
            const url = `/api-py/get-abp-by-user-id-region/${this.usrId}/${this.curReg.code}/${this.repYear}`
            let response = [];
            try {
                response = await fetch(url);
                if (response.status === 200) {
                    response = await response.json();
                } else {
                    this.makeToast('danger', 'Ошибка загрузки АБП', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                response = [];
                this.makeToast('danger', 'Ошибка загрузки АБП', error.toString());
            }

            if (response && response.length > 0) {
                response.sort((a, b) => (a.abp - b.abp > 0) ? 1 : -1);
                this.abpBase = this.setIdArr([{name_ru: 'Все', name_kk: 'Барлығы', ppr: null}, ...response], 'abp');
            }

            if (this.abpBase.length > 0) {
                this.curAbp = this.abpBase[0];
            } else {
                this.curAbp = null;
            }
            await this.chgAbp();
            // await this.chgData();

        },
        async chgAbp() {
            this.progBase = [];
            this.curProg = null;
            this.subProgBase = [];
            this.curSubProg = null;
            await this.loadProg();
        },

        async loadProg() {
            let response = [];
            this.progBase = [];

            try {
                const req = {
                    year: this.repYear,
                    region: this.curReg.code,
                    abp: this.curAbp?.abp ? this.curAbp.abp: 0
                }
                await axios.get('/api-py/budget-execution-pf-ipf/prg', {
                    params: req
                }).then(resp => {
                    response = resp.data;
                })
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки программ', error.toString());
            }
            if (response && response.length > 0) {
                this.progBase = this.setIdArr([{name_ru: 'Все', name_kk: 'Барлығы', ppr: null}, ...response], 'prg');
            }

            if (this.progBase.length > 0) {
                this.curProg = this.progBase[0];
            } else {
                this.curProg = null;
            }
            await this.chgProg();
        },

        async chgProg() {
            this.subProgBase = [];
            this.curSubProg = null;
            await this.loadSubProg();
        },

        async loadSubProg() {
            let response = [];
            this.subProgBase = [];

            try {
                const req = {
                    year: this.repYear,
                    region: this.curReg.code,
                    abp: this.curAbp?.abp ? this.curAbp.abp: 0,
                    prg: this.curProg?.prg ? this.curProg.prg: 0
                }
                await axios.get('/api-py/budget-execution-pf-ipf/ppr', {
                    params: req
                }).then(resp => {
                    response = resp.data;
                })
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки подпрограмм', error.toString());
                response = [];
            }
            if (response && response.length > 0) {
                this.subProgBase = this.setIdArr([{name_ru: 'Все', name_kk: 'Барлығы', ppr: null}, ...response], 'ppr');
            }

            if (this.subProgBase.length > 0) {
                this.curSubProg = this.subProgBase[0];
            } else {
                this.curSubProg = null;
            }
            await this.chgSubProg();
        },

        async chgSubProg() {
            await this.loadCurSpf();
        },

        async loadCurSpf() {
            this.spfBase = [];
            let response = [];

            try {
                const req = {
                    year: this.repYear,
                    region: this.curReg.code,
                    abp: this.curAbp?.abp ? this.curAbp.abp: 0,
                    prg: this.curProg?.prg ? this.curProg.prg: 0,
                    ppr: this.curSubProg?.ppr ? this.curSubProg.ppr: 0,
                }
                await axios.get('/api-py/budget-execution-pf-ipf/spf', {
                    params: req
                }).then(resp => {
                    response = resp.data;
                })
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса loadCurSpf()', error.toString());
            }

            if (response && response.length > 0) {
                this.spfBase = this.setIdArr([{name_ru: 'Все', name_kk: 'Барлығы', spf: null}, ...response], 'spf');
            }

            if (this.spfBase.length > 0) {
                this.curSpf = this.spfBase[0];
            } else {
                this.curSpf = null;
            }
        },

        async chgData() {
            this.$refs.drop.hide(true);
            await this.getCurrentForm()
            this.switchTab()
            this.budgetFormObligation.splice(0);
            this.budgetFormObligationData.splice(0);
            this.budgetFormPayment.splice(0);
            this.budgetFormPaymentData.splice(0);
            // await this.loadDataForObligation();
            // await this.loadDataForPayment();
            await this.prepareFormObligation();
            this.bar = 50;
            await this.prepareFormPayment();
            this.bar = 100;
            this.$emit('curYear', this.repYear);
        },
        sortedData(data, by) {
            if (['bip_code'].includes(by)) data.sort((a, b) => a[by].localeCompare(b[by]))
            else data.sort((a, b) => a[by] - b[by])
        },
        colapsable(data, sortKeys) {
            this.$set(data, 'collapse', true);
            // console.log(sortKeys)
            if ('child_list' in data && data.child_list) {
                if (sortKeys.length) {
                    this.sortedData(data.child_list, sortKeys.pop())
                }
                for (const el of data.child_list) { this.colapsable(el, Object.assign([], sortKeys)) }
            } else if ('form_child_list' in data && data.form_child_list) {
                if (sortKeys.length) {
                    this.sortedData(data.form_child_list, sortKeys.pop())
                }
                for (const el of data.form_child_list) { this.colapsable(el, Object.assign([], sortKeys)) }
            } else if ('spf_list' in data && data.spf_list) {
                if (sortKeys.length) {
                    this.sortedData(data.spf_list, sortKeys.pop())
                }
                for (const el of data.spf_list) { this.colapsable(el, Object.assign([], sortKeys)) }
            }
        },

        async prepareFormObligation() {
            const sortDepth = Object.assign([], this.sortDepth).reverse()
            this.budgetFormObligation.splice(0);
            this.budgetFormObligationData.splice(0);
            const dataOblig = await this.getData('obligation');
            if (dataOblig && dataOblig.length > 0) {
                this.budgetFormObligation = dataOblig
            }
            this.sortedData(this.budgetFormObligation, sortDepth.pop())
            for (const el of this.budgetFormObligation) {
                this.colapsable(el, Object.assign([], sortDepth))
            }
        }, // подготовка отображения данных обязательств

        async prepareFormPayment() {
            const sortDepth = Object.assign([], this.sortDepth).reverse()
            this.budgetFormPayment.splice(0);
            this.budgetFormPaymentData.splice(0);
            const dataPayment = await this.getData('payment');
            if (dataPayment && dataPayment.length > 0) {
                this.budgetFormPayment = dataPayment
            }
            this.sortedData(this.budgetFormPayment, sortDepth.pop())
            for (const el of this.budgetFormPayment) {
                this.colapsable(el, Object.assign([], sortDepth))
            }
        }, // подготовка отображения данных платежей

        templateData(dataItem) {
            Object.defineProperty(dataItem, 'deviation', {
                get: function () {
                    const sum = (parseFloat(dataItem.january) + parseFloat(dataItem.february) + parseFloat(dataItem.march)
                        + parseFloat(dataItem.april) + parseFloat(dataItem.may) + parseFloat(dataItem.june)
                        + parseFloat(dataItem.july) + parseFloat(dataItem.august) + parseFloat(dataItem.september)
                        + parseFloat(dataItem.october) + parseFloat(dataItem.november) + parseFloat(dataItem.december));
                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                }
            });
        },

        async getData(type) {
            let values = [];
            try {
                let response = [];
                const queryString = {
                    year: this.repYear,
                    region: this.curReg.code,
                    type: type
                };
                if (this.curAbp && this.curAbp.hasOwnProperty('abp') && this.curAbp.abp) {
                    this.$set(queryString, 'abp', this.curAbp.abp);
                }
                if (this.curProg && this.curProg.hasOwnProperty('prg') && this.curProg.prg) {
                    this.$set(queryString, 'prg', this.curProg.prg);
                }
                if (this.curSubProg && this.curSubProg.hasOwnProperty('ppr') && this.curSubProg.ppr) {
                    this.$set(queryString, 'ppr', this.curSubProg.ppr);
                }
                if (this.curSpf && this.curSpf.hasOwnProperty('spf') && this.curSpf.spf) {
                    this.$set(queryString, 'spf', this.curSpf.spf);
                }
                if (this.selectedStatus && this.selectedStatus.hasOwnProperty('code') && this.selectedStatus.code) {
                    this.$set(queryString, 'status', this.selectedStatus.code);
                }
                response = await axios.get('/api/budget-execution/spf', {params: queryString});
                response = response.data;
                values = await response;

                if (values.length === 0) {
                    return;
                }

                // eslint-disable-next-line consistent-return
                return values;
            } catch (error) {
                this.$emit('chgLoad', false);
                this.makeToast('danger', `Ошибка запроса ${type} in loadData()`, error.toString());
            }
        },

        createTable(elem, parent_id, typeTable) {
            const that = this;
            // создание таблицы на основе дерева
            const item = Object.assign({}, elem);

            this.$set(item, 'parent_id', parent_id);
            this.$set(item, 'visible', true);
            if (item.hasOwnProperty('type') && item.type === 1) item.is_children_loaded = false
            Object.defineProperty(item, 'parent', {
                get: function () {
                    if (typeTable === 'obligation') {
                        for (const row of that.budgetFormObligation) {
                            if (item.parent_id === row.id) {
                                return row;
                            }
                        }
                        return null;
                    } else if (typeTable === 'payment') {
                        for (const row of that.budgetFormPayment) {
                            if (item.parent_id === row.id) {
                                return row;
                            }
                        }
                        return null;
                    }
                }
            });
            // const sums = this.sumOfChildren(item, typeTable)
            if (item.hasOwnProperty('type')) {
                this.$set(item, 'open', false);
                this.$set(item, 'hasChild', true);
            } else {
                this.$set(item, 'open', false);
                this.$set(item, 'hasChild', true);
            }

            if (item) {
                if (typeTable === 'obligation') {
                    this.$set(item, 'index', this.budgetFormObligation.length);
                    this.$set(this.budgetFormObligation, this.budgetFormObligation.length, item);
                } else if (typeTable === 'payment') {
                    this.$set(item, 'index', this.budgetFormPayment.length);
                    this.$set(this.budgetFormPayment, this.budgetFormPayment.length, item);
                }
            }

            if (item.hasOwnProperty('hasChild')) {
                if (item.hasOwnProperty('form_child_list') && item.form_child_list && item.form_child_list.length > 0) {
                    // for (const ch of item.form_child_list) {
                    //     this.createTable(ch, item.id, typeTable);
                    // }
                    item.form_child_list = [];
                } else if (item.hasOwnProperty('child_list') && item.child_list && item.child_list.length > 0) {
                    // for (const ch of item.child_list) {
                    //     this.createTable(ch, item.id, typeTable);
                    // }
                    delete item.child_list;
                } else if (item.hasOwnProperty('spf_list') && item.spf_list && item.spf_list.length > 0) {
                    // for (const ch of item.spf_list) {
                    //     this.createTable(ch, item.id, typeTable);
                    // }
                    delete item.spf_list;
                }
            }
        }, // древовидную выборку преобразовывает в таблицу (для отображения)

        reSum(parent, field, typeTable) {
            let sum = 0;
            if (typeTable === 'obligation') {
                this.budgetFormObligation.forEach((row) => {
                    if ((row.parent_id === parent.id)) {
                        if (!row[field]) {
                            sum += 0;
                        } else {
                            sum += parseFloat(row[field]);
                        }
                        // sum += parseFloat(row[field]);
                    }
                });
            } else if (typeTable === 'payment') {
                this.budgetFormPayment.forEach((row) => {
                    if ((row.parent_id === parent.id)) {
                        if (!row[field]) {
                            sum += 0;
                        } else {
                            sum += parseFloat(row[field]);
                        }
                        // sum += parseFloat(row[field]);
                    }
                });
            }

            return Math.round(sum);
        }, // пересчет суммы
        getTableParent(talbe, field, value) {
            for (let i = 0; i < talbe.length; i++) {
                if (talbe[i][field] === value) return talbe[i]
            }
        },
        getLowestChildren(children, sums) {
            for (const child of children) {
                if (child.type) {
                    if (child.hasOwnProperty('form_child_list') && child.form_child_list && child.form_child_list.length > 0) {
                        this.getLowestChildren(child.form_child_list, sums)
                    } else if (child.hasOwnProperty('child_list') && child.child_list && child.child_list.length > 0) {
                        this.getLowestChildren(child.child_list, sums)
                    } else if (child.hasOwnProperty('spf_list') && child.spf_list && child.spf_list.length > 0) {
                        this.getLowestChildren(child.spf_list, sums)
                    }
                } else {
                    for (const f of this.calcFlds) {

                        if (!child[f]) {
                            sums[f] += 0
                        } else {
                            sums[f] += child[f]
                        }
                    }
                }
            }
        },
        sumOfChildren(parent, type) {
            let parent_data
            if (type === 'obligation') {
                parent_data = this.getTableParent(this.budgetFormObligationData, 'id', parent.id)
            } else if (type === 'payment') {
                parent_data = this.getTableParent(this.budgetFormObligationData, 'id', parent.id)
            }
            const sums = {}
            for (const f of this.calcFlds) {
                sums[f] = 0
            }
            this.getLowestChildren(parent_data.child_list, sums)
            return sums
        },
        switchTab(isExternal = false) {
            const tabConfig = {
                name: this.$route.name,
                params: {
                    form: this.form
                },
                query: {}
            }
            let hasChanges = false;
            hasChanges = hasChanges || this.$route.params.form !== this.form
            if (!this.queryParams) {
                if (this.currentForm) {
                    tabConfig.query.region = this.currentForm.region
                    tabConfig.query.year = this.currentForm.year
                    console.log(this.currentForm)
                }
            } else {
                console.log(this.queryParams)
                tabConfig.query.region = this.queryParams?.region
                tabConfig.query.year = this.queryParams?.year
            }
            hasChanges = hasChanges || this.$route.query?.region  !== tabConfig.query.region
            hasChanges = hasChanges || this.$route.query?.year  !== tabConfig.query.year
            if (hasChanges && (this.$route.params.form === this.form || isExternal)) {
                this.$router.replace(tabConfig)
            }
        },
        toggleShowObligation() {
            this.showObligation = !this.showObligation;
        },

        toggleShowPayment() {
            this.showPayment = !this.showPayment;
        },

        rowClass(item, type) {
            if (!item || type !== 'row') {
                return;
            }
            if (!item.visible) {
                return 'is-hidden';
            }
        }, // задает класс 'is-hidden' заданной строке

        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            const refItem = this.$refs[refName];
            setTimeout(() => refItem.$el.focus(), 100);
        },

        inputFixed(item, field, value) {
            if (value) {
                this.$set(item, field, parseFloat(value));
            } else {
                this.$set(item, field, 0);
            }
        },

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            if (!event.target.value) {
                event.target.value = 0;
            }
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        keyPress: function (event, pattern) {
            // const regex = new RegExp('^[0-9]+$');
            // const regex = new RegExp('^-?\\d*\\d{0,9}$');
            // const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');

            const regex = new RegExp(pattern);
            const charCode = event.keyCode;
            const key = String.fromCharCode(charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            return true;
        }, // вводит по заданному паттерну

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение

        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined' || isNaN(value) || isFinite(value) || (value === null)) {
                return 0;
            }
        },

        setNameLang(obj, codeName) {
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) {
                txt = obj.name_ru;
            }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                if (obj[codeName]) {
                    txt = obj[codeName] + ' - ' + txt;
                }
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            return el;
        },

        setIdArr(arr, codeName) {
            const result = [];
            if (arr && arr.length > 0) {
                for (const el of arr) {
                    if (result.length > 0 && el[codeName] === result[result.length - 1][codeName]) {
                        result[result.length - 1].idArr.push(el.id);
                    } else {
                        result.push(Object.assign({idArr: [el.id]}, el));
                    }
                }
            }
            return result;
        },
        getDownloadFilter() {
            const filter = {
                region: this.curReg.code,
                year: this.repYear
            }
            if (this.curAbp & this.curAbp.hasOwnProperty('code') & this.curAbp.code) {
                filter.abp = this.curAbp.code
                if (this.curProg & this.curProg.hasOwnProperty('code') & this.curProg.code) {
                    filter.prg = this.curProg.code
                    if (this.curSubProg & this.curSubProg.hasOwnProperty('code') & this.curSubProg.code) {
                        filter.ppr = this.curSubProg.code
                    }
                }
            }
            return filter
        },
        downloadRepSpfPayments() {
            const filter = this.getDownloadFilter()
            Ax(
                {
                    url: '/api-py/get-budget-execution-spf-report/' + JSON.stringify(filter) + '/16/payment',
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план финансирования по платежам.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepSpfPayments()', error.toString());
                }
            );
        },

        downloadRepSpfPayments17() {
            const filter = this.getDownloadFilter()
            Ax(
                {
                    url: '/api-py/get-budget-execution-spf-report/' + JSON.stringify(filter) + '/17/payment',
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план финансирования по платежам.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepSpfPayments17()', error.toString());
                }
            );
        },

        downloadRepSpfObligations() {
            const filter = this.getDownloadFilter()
            Ax(
                {
                    url: '/api-py/get-budget-execution-spf-report/' + JSON.stringify(filter) + '/18/obligation',
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план финансирования по обязательствам.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepSpfObligations()', error.toString());
                }
            );
        },

        downloadRepSpfObligations19() {
            const filter = this.getDownloadFilter()
            Ax(
                {
                    url: '/api-py/get-budget-execution-spf-report/' + JSON.stringify(filter) + '/19/obligation',
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план финансирования по обязательствам.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepSpfObligations19()', error.toString());
                }
            );
        },

        async getCurrentForm() {
            if (this.curReg && this.curReg.hasOwnProperty('code') && this.curReg.code) {
                await axios.get(`/api/budget-execution-pf-request/UF?year=${this.repYear}&region=${this.curReg.code}`)
                    .then(resp => {
                        if (resp.status === 200) {
                            this.currentForm = resp.data
                            if (this.previousFormId !== this.currentForm.id) {
                                if (this.statusListPf.length) {
                                    if (this.currentForm && this.currentForm.hasOwnProperty('status') && this.currentForm.status.status) {
                                        if (this.currentForm.status.status === 39) {
                                            this.selectedStatus = this.statusListPf.find(el => { if (el.code === 39) return el })
                                        } else {
                                            this.selectedStatus = this.statusListPf.find(el => { if (el.code === 32) return el })
                                        }
                                    }
                                }
                                this.previousFormId = this.currentForm.id
                            }
                        }
                    })
            }
        },
        async getCurrentSPPForm() {
            if (this.curReg && this.curReg.hasOwnProperty('code') && this.curReg.code) {
                await axios.get(`/api/budget-execution-pf-request/income?year=${this.repYear}&region=${this.curReg.code}`)
                    .then(resp => {
                        if (resp.status === 200) {
                            this.currentSPPForm = resp.data
                        }
                    })
            }
        },
        async getStatusList(mode) {
            try {
                let statusList = [];
                const response = await axios.get(`/api-py/get-status-list/${mode}`);
                if (response.status === 200) {
                    statusList = response.data;
                }
                return statusList;
            } catch (e) {
                console.error("Error fetching status list:", e);
                return [];
            }
        },
        flk0Agr() {
            let total = 0
            for (const el of this.budgetFormPayment) {
                for (const mon of this.months) {
                    total += el[mon]
                }
            }
            return total > 0;
        },
        async agrClick(data) {
            if ([26, 37, 39].includes(this.currentSPPForm.status.status)) {
                this.makeToast('danger', 'Сначала отправьте на доработку Сводный план поступлений')
                return;
            }

            const flk0check = this.flk0Agr()
            if (26 === data.status && (!this.isChildsAgreedUF || !flk0check)) {
                if (!flk0check) {
                    this.makeToast('danger', 'Согласование', 'Данное действие не доступно')
                    return;
                }
                this.makeToast('warning', 'Согласование', 'Необходимо согласовать ПФ по всем администраторам бюджетных программ!')
                return;
            }
            await axios.post(
                '/api/budget-execution-pf-status',
                {
                    budgetExecutionPfId: this.currentForm.id,
                    comment: data.commentTxt,
                    status: data.status
                }
            ).then(res => {
                if (res.status === 200) {
                    this.chgData()
                    EventBus.$emit('formSPFChanged', this.currentForm)
                }
            })
        },
        async loadOperations() {
            this.operationCode = [];
            if (store.state.user.sub === null) { return; }
            let result = null;
            try {
                result = await fetch(encodeURI(`/api/um/module/link?user=${store.state.user.sub}&modulecode=${this.moduleCode}`))
                    .then(response => response.json());
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки операций пользователя', error.toString());
                return;
            }
            if (result.operations) { this.operationCode = result.operations; }
        },
        async agreementEvent(show = true) {
            this.selectArr = [];
            const params = { modeCode: this.mode, operationCode: this.operationCode, agrCode: this.currentForm.status.status };
            if (!show) { this.agrEnabled = false; }
            let result = [];
            try {
                const response = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
                result = await response.json();
            } catch (error) {
                // this.makeToast('danger', 'Ошибка get-agreement-step-next-back', 'Ошибка загрузки шагов согласования!');
                return;
            }
            if (result.length === 0) {
                this.makeToast('warning', 'Согласование', 'Нет доступных шагов согласования!');
                return;
            }
            this.agrBtnLst = { back: [], forward: [] };

            for (const el of result) {
                if (el.stepType === 1) {
                    this.agrBtnLst.back.push(el);
                } else {
                    this.agrBtnLst.forward.push(el);
                }
            }
            if (this.agrBtnLst.back.length || this.agrBtnLst.forward.length) {
                this.agrEnabled = true;
            }
            if (show) {
                // eslint-disable-next-line
                // @ts-ignore
                this.$refs.refAgrModal.showEvent();
            }
        },
        getFullName(row) {
            if (row.gu) {
                return `индивидуальный план финансирования на ${row.year} по ${row.gu}`
            }
            return `индивидуальный план финансирования на ${row.year}`
        },

        getLocalStatus(value) {
            const status = value.status.status;
            const curStatus = this.statusList.filter((item) => item.code === status);
            if (!curStatus || !curStatus.length) return status;
            const localName = curStatus[0]["name_" + this.$i18n.locale];
            return localName;
        },
        async formationIpfFormChanged(formData) {
            if (this.currentForm.id !== formData.parent) return;
            const url = `/api/budget-execution-pf-request/UF?year=${formData.year}&region=${formData.region}`
            await axios.get(url)
                .then(resp => {
                    if (resp.status === 200) {
                        this.currentForm = resp.data
                    }
                })
        },

        async openHistory(agrObj) {
            if (agrObj !== null) {
                await this.$refs.refHistModal.showEvent(agrObj);
            }
        }
    },
    computed: {
        usrId() {
            if (store.state.user.sub === undefined) {
                return null;
            }
            return store.state.user.sub;
        },
        abp() {
            const res = [];
            for (const el of this.abpBase) {
                res.push(this.setNameLang(el, 'abp'));
            }

            if (this.curAbp !== null) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.curAbp = this.setNameLang(this.curAbp, 'abp');
            }
            return res;
        },
        regions() {
            const res = [];
            if (this.regBase) {
                for (const el of this.regBase) {
                    res.push(this.setNameLang(el, 'code'));
                }
            }
            if (this.curReg !== null) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.curReg = this.setNameLang(this.curReg, 'code');
            }
            return res;
        },
        prog(){
            const res = [];
            for (const el of this.progBase) {
                res.push(this.setNameLang(el, 'prg'));
            }
            if (this.curProg !== null) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.curProg = this.setNameLang(this.curProg, 'prg');
            }
            return res;
        },
        subProg() {
            const res = [];
            for (const el of this.subProgBase) {
                res.push(this.setNameLang(el, 'ppr'));
            }
            if (this.curSubProg !== null) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.curSubProg = this.setNameLang(this.curSubProg, 'ppr');
            }
            return res;
        },
        spf() {
            const res = [];
            for (const el of this.spfBase) {
                res.push(this.setNameLang(el, 'spf'));
            }

            if (this.curSpf !== null) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.curSpf = this.setNameLang(this.curSpf, 'spf');
            }
            return res;
        },
        sortDepth() {
            return ['gr', 'pgr', 'abp', 'prg', 'ppr', 'spf', 'bip_code']
        }




    }
};
</script>

<style>
.icon-btn{
    width: 20px;
    height: 20px;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important;
    background-color: transparent;
    border: 1px solid rgba(28, 42, 62, 1);
    border-radius: 50%;
    margin: 0;
}
.icon-btn i{
    font-size: 0.4444444444rem;
    color: rgba(28, 42, 62, 1);
}
</style>
